import { InlineAlert } from "@/shared/components";
import { useCapabilities } from "@/shared/hooks/useCapabilities";
import { usePermissions } from "@/shared/hooks/usePermissions";

/**
 * Tells an administrator when the API's env file and its database disagree on the edition
 * (ROOT_ORG_TYPE says one thing, the database's root organisation another). The database
 * wins, so without this the portal silently runs as the other edition.
 */
export default function EditionMismatchBanner() {
  const { capabilities } = useCapabilities();
  const { can } = usePermissions();
  if (!capabilities?.edition_mismatch || !can("settings", "update")) return null;
  const wanted = capabilities.configured_edition;
  return (
    <InlineAlert tone="warning" className="m-2 mb-0">
      The API's env file says {wanted.toLowerCase()} (ROOT_ORG_TYPE={wanted}), but its database is
      set up as {capabilities.edition.toLowerCase()}, so the portal runs as{" "}
      {capabilities.edition.toLowerCase()}. On the API server run{" "}
      <code>scripts\switch-edition.ps1 {wanted.toLowerCase()}</code> (it points DATABASE_URL at the{" "}
      {wanted.toLowerCase()} database), then restart the API.
    </InlineAlert>
  );
}
